(function () {
  if (window.rhSimpleQuickAddLoaded) return;

  window.rhSimpleQuickAddLoaded = true;

  document.addEventListener('click', async function (event) {
    const openButton = event.target.closest('.rh-simple-quick-add__open');
    const closeButton = event.target.closest('.rh-simple-quick-add__close');
    const valueButton = event.target.closest('.rh-simple-quick-add__value');
    const addButton = event.target.closest('.rh-simple-quick-add__add');
    const directButton = event.target.closest('.rh-simple-quick-add__direct');
    const mobileSiblingButton = event.target.closest('.rh-simple-quick-add__mobile-sibling');
    const mobileGalleryItem = event.target.closest('.rh-simple-quick-add__mobile-gallery-item');
    const lightboxCloseButton = event.target.closest('.rh-simple-quick-add__lightbox-close');
    const lightboxBackdrop = event.target.classList && event.target.classList.contains('rh-simple-quick-add__lightbox');

    if (lightboxCloseButton || lightboxBackdrop) {
      event.preventDefault();
      rhSimpleQuickAddCloseLightbox();
      return;
    }

    if (
      mobileGalleryItem &&
      mobileGalleryItem.closest('.rh-simple-quick-add__panel.is-rh-mobile-portal')
    ) {
      event.preventDefault();

      const img = mobileGalleryItem.querySelector('img');
      const src =
        mobileGalleryItem.dataset.rhLightboxSrc ||
        (img ? img.currentSrc || img.src || img.getAttribute('src') : '');

      const alt = img ? img.alt || '' : '';

      if (src) {
        rhSimpleQuickAddOpenLightbox(src, alt);
      }

      return;
    }

    if (openButton) {
      event.preventDefault();

      const root = openButton.closest('.rh-simple-quick-add');
      let panel = root && root.querySelector('.rh-simple-quick-add__panel');

      if (!root || !panel) return;

      rhSimpleQuickAddEnsureInitialState(root);

      openButton.classList.add('is-loading');

      try {
        await rhSimpleQuickAddSyncWithActiveSibling(root);
      } catch (error) {
        console.warn('[RH Quick Add] No se pudo sincronizar sibling:', error);
      }

      openButton.classList.remove('is-loading');

      panel = rhSimpleQuickAddGetPanel(root);
      if (!panel) return;

      const shouldOpen = panel.hidden;

      closeAllPanels();

      if (shouldOpen) {
        openPanel(root, panel);
      } else {
        closePanel(root);
      }

      rhSimpleQuickAddPrepareMobile(root);
      rhSimpleQuickAddUpdate(root);
      return;
    }

    if (closeButton) {
      event.preventDefault();

      const panel = closeButton.closest('.rh-simple-quick-add__panel');
      const root = rhSimpleQuickAddGetRootFromPanel(panel) || closeButton.closest('.rh-simple-quick-add');

      closePanel(root);
      return;
    }

    if (mobileSiblingButton) {
      event.preventDefault();

      if (mobileSiblingButton.classList.contains('is-loading')) return;

      const panel = mobileSiblingButton.closest('.rh-simple-quick-add__panel');
      const root = rhSimpleQuickAddGetRootFromPanel(panel);

      if (!root) return;

      const handle = mobileSiblingButton.dataset.handle;

      if (!handle) return;

      if (root.dataset.rhActiveHandle === handle) {
        rhSimpleQuickAddRenderMobileSiblings(root);
        rhSimpleQuickAddRenderMobileDetailsLink(root);
        return;
      }

      mobileSiblingButton.classList.add('is-loading');

      try {
        await rhSimpleQuickAddLoadProductByHandle(root, handle);
        rhSimpleQuickAddRenderMobileSiblings(root);
        rhSimpleQuickAddRenderMobileDetailsLink(root);
        rhSimpleQuickAddResetSelection(root);
        rhSimpleQuickAddUpdate(root);
      } catch (error) {
        console.warn('[RH Quick Add] No se pudo cargar el sibling mobile:', error);

        const currentPanel = rhSimpleQuickAddGetPanel(root);
        const message = currentPanel
          ? currentPanel.querySelector('.rh-simple-quick-add__message')
          : root.querySelector('.rh-simple-quick-add__message');

        if (message) {
          message.textContent = error.message || 'No se pudo cargar el producto seleccionado.';
        }
      }

      mobileSiblingButton.classList.remove('is-loading');
      return;
    }

    if (valueButton) {
      event.preventDefault();

      if (valueButton.classList.contains('is-disabled')) return;

      const panel = valueButton.closest('.rh-simple-quick-add__panel');
      const root = rhSimpleQuickAddGetRootFromPanel(panel) || valueButton.closest('.rh-simple-quick-add');

      if (!root) return;

      const optionIndex = valueButton.dataset.rhOptionIndex;
      const scope = panel || root;

      scope
        .querySelectorAll('.rh-simple-quick-add__value[data-rh-option-index="' + optionIndex + '"]')
        .forEach(function (button) {
          button.classList.remove('is-selected');
        });

      valueButton.classList.add('is-selected');

      rhSimpleQuickAddUpdate(root);
      return;
    }

    if (addButton) {
      event.preventDefault();

      const panel = addButton.closest('.rh-simple-quick-add__panel');
      const root = rhSimpleQuickAddGetRootFromPanel(panel) || addButton.closest('.rh-simple-quick-add');

      rhSimpleQuickAddSubmit(root, addButton.dataset.variantId, addButton);
      return;
    }

    if (directButton) {
      event.preventDefault();

      const root = directButton.closest('.rh-simple-quick-add');
      rhSimpleQuickAddSubmit(root, directButton.dataset.variantId, directButton);
      return;
    }

    if (!rhSimpleQuickAddIsMobile()) {
      const card = rhSimpleQuickAddGetCardFromElement(event.target);
      const openRoot = card && card.querySelector('.rh-simple-quick-add.is-panel-open');

      if (
        openRoot &&
        !event.target.closest('.rh-simple-quick-add__panel') &&
        !event.target.closest('.rh-simple-quick-add__open') &&
        !event.target.closest('.rh-simple-quick-add__add') &&
        rhSimpleQuickAddLooksLikeExternalSiblingClick(event.target)
      ) {
        const fallbackHandle = rhSimpleQuickAddGetHandleFromElement(event.target);

        rhSimpleQuickAddQueueDesktopSiblingSync(openRoot, fallbackHandle);
        return;
      }
    }

    if (
      !event.target.closest('.rh-simple-quick-add') &&
      !event.target.closest('.rh-simple-quick-add__panel') &&
      !event.target.closest('.rh-simple-quick-add__lightbox')
    ) {
      closeAllPanels();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      const openLightbox = document.querySelector('.rh-simple-quick-add__lightbox.is-open');

      if (openLightbox) {
        rhSimpleQuickAddCloseLightbox();
        return;
      }

      closeAllPanels();
    }
  });

  window.addEventListener('resize', function () {
    if (!rhSimpleQuickAddIsMobile()) {
      rhSimpleQuickAddCloseLightbox();

      document.querySelectorAll('.rh-simple-quick-add__panel.is-rh-mobile-portal').forEach(function (panel) {
        const root = rhSimpleQuickAddGetRootFromPanel(panel);

        if (root) {
          rhSimpleQuickAddReturnPanelToRoot(root, panel);
          panel.classList.remove('is-rh-mobile-portal');
          root.classList.remove('is-panel-open');
          rhSimpleQuickAddStopDesktopSiblingObserver(root);
        }
      });

      document.body.classList.remove('rh-simple-quick-add-open');
    } else {
      document.querySelectorAll('.rh-simple-quick-add.is-panel-open').forEach(function (root) {
        rhSimpleQuickAddStopDesktopSiblingObserver(root);
      });
    }
  });

  function rhSimpleQuickAddIsMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function rhSimpleQuickAddEnsureInitialState(root) {
    if (!root || root.rhSimpleQuickAddInitialState) return;

    root.rhSimpleQuickAddInitialState = {
      handle: root.dataset.rhActiveHandle || root.dataset.rhProductHandle || '',
      productHandle: root.dataset.rhProductHandle || '',
      title: root.dataset.rhProductTitle || '',
      url: root.dataset.rhProductUrl || '',
      tags: root.dataset.rhProductTags || '[]',
      images: root.dataset.rhProductImages || '[]',
      variants: root.dataset.rhVariants || '[]',
      options: root.dataset.rhOptions || '[]'
    };
  }

  function rhSimpleQuickAddRestoreInitialState(root) {
    if (!root || !root.rhSimpleQuickAddInitialState) return;

    const state = root.rhSimpleQuickAddInitialState;

    root.dataset.rhActiveHandle = state.handle;
    root.dataset.rhProductHandle = state.productHandle || state.handle;
    root.dataset.rhProductTitle = state.title;
    root.dataset.rhProductUrl = state.url;
    root.dataset.rhProductTags = state.tags;
    root.dataset.rhProductImages = state.images;
    root.dataset.rhVariants = state.variants;
    root.dataset.rhOptions = state.options;

    const options = rhSimpleQuickAddGetOptions(root);
    const variants = rhSimpleQuickAddGetVariants(root);

    rhSimpleQuickAddRenderOptions(root, options, variants);
    rhSimpleQuickAddPrepareMobile(root);
    rhSimpleQuickAddResetSelection(root);
  }

  function openPanel(root, panel) {
    closeAllPanels();

    if (rhSimpleQuickAddIsMobile()) {
      rhSimpleQuickAddMovePanelToBody(root, panel);
      panel.classList.add('is-rh-mobile-portal');
      document.body.classList.add('rh-simple-quick-add-open');
      rhSimpleQuickAddStopDesktopSiblingObserver(root);
    } else {
      panel.classList.remove('is-rh-mobile-portal');
      document.body.classList.remove('rh-simple-quick-add-open');
    }

    panel.hidden = false;

    root.classList.add('is-panel-open');
    root.classList.add('is-mobile-open');

    const open = root.querySelector('.rh-simple-quick-add__open');

    if (open) {
      open.setAttribute('aria-expanded', 'true');
    }

    if (!rhSimpleQuickAddIsMobile()) {
      rhSimpleQuickAddStartDesktopSiblingObserver(root);
    }
  }

  function closeAllPanels() {
    rhSimpleQuickAddCloseLightbox();

    document.querySelectorAll('.rh-simple-quick-add .rh-simple-quick-add__panel').forEach(function (panel) {
      const root = panel.closest('.rh-simple-quick-add');

      if (root) {
        closePanel(root);
      }
    });

    document.querySelectorAll('body > .rh-simple-quick-add__panel.is-rh-mobile-portal').forEach(function (panel) {
      const root = rhSimpleQuickAddGetRootFromPanel(panel);

      if (root) {
        closePanel(root);
      } else {
        panel.hidden = true;
        panel.classList.remove('is-rh-mobile-portal');
      }
    });

    document.body.classList.remove('rh-simple-quick-add-open');
  }

  function closePanel(root) {
    rhSimpleQuickAddCloseLightbox();

    if (!root) return;

    rhSimpleQuickAddStopDesktopSiblingObserver(root);

    const panel = rhSimpleQuickAddGetPanel(root);
    const open = root.querySelector('.rh-simple-quick-add__open');

    if (panel) {
      rhSimpleQuickAddResetSelection(root);

      panel.hidden = true;
      panel.classList.remove('is-rh-mobile-portal');
      rhSimpleQuickAddReturnPanelToRoot(root, panel);
    }

    if (open) {
      open.setAttribute('aria-expanded', 'false');
    }

    root.classList.remove('is-panel-open');
    root.classList.remove('is-mobile-open');
    root.classList.remove('is-syncing-sibling');
    delete root.dataset.rhPortalPanelId;
    delete root.dataset.rhSyncingSibling;

    document.body.classList.remove('rh-simple-quick-add-open');
  }

  function rhSimpleQuickAddMovePanelToBody(root, panel) {
    if (!root || !panel) return;

    if (panel.parentNode === document.body) return;

    const portalId = panel.id || 'RhQuickAddPortal-' + Date.now() + '-' + Math.floor(Math.random() * 1000);
    panel.id = portalId;
    root.dataset.rhPortalPanelId = portalId;

    document.body.appendChild(panel);
  }

  function rhSimpleQuickAddReturnPanelToRoot(root, panel) {
    if (!root || !panel) return;

    if (panel.closest('.rh-simple-quick-add') === root) return;

    root.appendChild(panel);
  }

  function rhSimpleQuickAddGetPanel(root) {
    if (!root) return null;

    let panel = root.querySelector('.rh-simple-quick-add__panel');

    if (!panel && root.dataset.rhPortalPanelId) {
      panel = document.getElementById(root.dataset.rhPortalPanelId);
    }

    return panel;
  }

  function rhSimpleQuickAddGetRootFromPanel(panel) {
    if (!panel) return null;

    const rootInside = panel.closest('.rh-simple-quick-add');

    if (rootInside) {
      return rootInside;
    }

    if (panel.id) {
      return document.querySelector('.rh-simple-quick-add[data-rh-portal-panel-id="' + panel.id + '"]');
    }

    return null;
  }

  function rhSimpleQuickAddResetSelection(root) {
    if (!root) return;

    const panel = rhSimpleQuickAddGetPanel(root);
    const scope = panel || root;

    scope.querySelectorAll('.rh-simple-quick-add__value.is-selected').forEach(function (button) {
      button.classList.remove('is-selected');
    });

    const add = scope.querySelector('.rh-simple-quick-add__add');
    const message = scope.querySelector('.rh-simple-quick-add__message');

    if (add) {
      add.disabled = true;
      add.removeAttribute('data-variant-id');
    }

    if (message) {
      message.textContent = '';
    }

    rhSimpleQuickAddRenderMobilePrice(root, null);
  }

  function rhSimpleQuickAddGetVariants(root) {
    try {
      return JSON.parse(root.dataset.rhVariants || '[]');
    } catch (error) {
      return [];
    }
  }

  function rhSimpleQuickAddGetOptions(root) {
    try {
      const options = JSON.parse(root.dataset.rhOptions || '[]');

      return options.map(function (option) {
        if (typeof option === 'string') return option;
        if (option && option.name) return option.name;
        return String(option);
      });
    } catch (error) {
      return [];
    }
  }

  function rhSimpleQuickAddGetSelected(root) {
    const options = rhSimpleQuickAddGetOptions(root);
    const selected = new Array(options.length).fill(null);

    const panel = rhSimpleQuickAddGetPanel(root);
    const scope = panel || root;

    scope.querySelectorAll('.rh-simple-quick-add__value.is-selected').forEach(function (button) {
      selected[Number(button.dataset.rhOptionIndex)] = button.dataset.rhOptionValue;
    });

    return selected;
  }

  function rhSimpleQuickAddVariantMatchesSelection(variant, selected, allowPartial) {
    const variantOptions = variant.options || [];

    for (let i = 0; i < selected.length; i++) {
      if (!selected[i] && allowPartial) continue;
      if (!selected[i] && !allowPartial) return false;
      if (variantOptions[i] !== selected[i]) return false;
    }

    return true;
  }

  function rhSimpleQuickAddFindVariant(root) {
    const variants = rhSimpleQuickAddGetVariants(root);
    const selected = rhSimpleQuickAddGetSelected(root);

    if (selected.some(function (value) { return !value; })) {
      return null;
    }

    return variants.find(function (variant) {
      return variant.available && rhSimpleQuickAddVariantMatchesSelection(variant, selected, false);
    }) || null;
  }

  function rhSimpleQuickAddGetFirstAvailableVariant(root) {
    const variants = rhSimpleQuickAddGetVariants(root);

    return variants.find(function (variant) {
      return variant.available;
    }) || variants[0] || null;
  }

  function rhSimpleQuickAddUpdate(root) {
    if (!root) return;

    const variants = rhSimpleQuickAddGetVariants(root);
    const selected = rhSimpleQuickAddGetSelected(root);
    const panel = rhSimpleQuickAddGetPanel(root);
    const scope = panel || root;

    const add = scope.querySelector('.rh-simple-quick-add__add');
    const message = scope.querySelector('.rh-simple-quick-add__message');

    if (!add) return;

    scope.querySelectorAll('.rh-simple-quick-add__value').forEach(function (button) {
      const index = Number(button.dataset.rhOptionIndex);
      const value = button.dataset.rhOptionValue;
      const testSelection = selected.slice();

      testSelection[index] = value;

      const hasAvailableCombination = variants.some(function (variant) {
        return variant.available && rhSimpleQuickAddVariantMatchesSelection(variant, testSelection, true);
      });

      button.classList.toggle('is-disabled', !hasAvailableCombination);
    });

    const variant = rhSimpleQuickAddFindVariant(root);

    if (variant) {
      add.disabled = false;
      add.dataset.variantId = variant.id;

      if (message) {
        message.textContent = '';
      }

      rhSimpleQuickAddRenderMobilePrice(root, variant);
    } else {
      add.disabled = true;
      add.removeAttribute('data-variant-id');

      if (message) {
        if (selected.some(function (value) { return !value; })) {
          message.textContent = 'Selecciona las opciones disponibles.';
        } else {
          message.textContent = 'Esta combinación no está disponible.';
        }
      }

      rhSimpleQuickAddRenderMobilePrice(root, null);
    }
  }

  async function rhSimpleQuickAddSyncWithActiveSibling(root) {
    rhSimpleQuickAddEnsureInitialState(root);

    const card = rhSimpleQuickAddGetCard(root);

    if (!card) {
      rhSimpleQuickAddRestoreInitialState(root);
      return;
    }

    const handle = rhSimpleQuickAddFindActiveHandleInCard(card, root);

    if (!handle) {
      rhSimpleQuickAddRestoreInitialState(root);
      return;
    }

    if (root.dataset.rhActiveHandle === handle) return;

    await rhSimpleQuickAddLoadProductByHandle(root, handle);
  }

  async function rhSimpleQuickAddLoadProductByHandle(root, handle) {
    const response = await fetch('/products/' + handle + '.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('No se pudo cargar el producto seleccionado.');
    }

    const product = await response.json();

    const variants = product.variants || [];
    const options = normalizeProductOptions(product.options || []);

    root.dataset.rhActiveHandle = handle;
    root.dataset.rhProductHandle = handle;
    root.dataset.rhProductTitle = product.title || '';
    root.dataset.rhProductUrl = product.url || '/products/' + handle;
    root.dataset.rhProductTags = JSON.stringify(rhSimpleQuickAddNormalizeTags(product.tags || []));
    root.dataset.rhProductImages = JSON.stringify(rhSimpleQuickAddNormalizeImages(product));
    root.dataset.rhVariants = JSON.stringify(variants);
    root.dataset.rhOptions = JSON.stringify(options);

    root.rhSimpleQuickAddProduct = product;

    rhSimpleQuickAddRenderOptions(root, options, variants);
    rhSimpleQuickAddPrepareMobile(root);
    rhSimpleQuickAddResetSelection(root);
  }

  function rhSimpleQuickAddRenderOptions(root, options, variants) {
    const panel = rhSimpleQuickAddGetPanel(root);
    if (!panel) return;

    const addButton = panel.querySelector('.rh-simple-quick-add__add');
    const message = panel.querySelector('.rh-simple-quick-add__message');

    if (!addButton) return;

    panel.querySelectorAll('.rh-simple-quick-add__option').forEach(function (optionBlock) {
      optionBlock.remove();
    });

    if (
      options.length === 1 &&
      String(options[0]).toLowerCase() === 'title' &&
      variants.length === 1
    ) {
      addButton.dataset.variantId = variants[0].id;
      addButton.disabled = !variants[0].available;
      addButton.textContent = variants[0].available ? 'Agregar al carrito' : 'Agotado';

      if (message) {
        message.textContent = variants[0].available ? '' : 'Producto agotado.';
      }

      return;
    }

    options.forEach(function (optionName, optionIndex) {
      const values = [];

      variants.forEach(function (variant) {
        const value = variant.options && variant.options[optionIndex];

        if (value && values.indexOf(value) === -1) {
          values.push(value);
        }
      });

      const optionBlock = document.createElement('div');
      optionBlock.className = 'rh-simple-quick-add__option';
      optionBlock.dataset.rhOptionIndex = String(optionIndex);

      const label = document.createElement('p');
      label.className = 'rh-simple-quick-add__label';
      label.textContent = optionName;

      const valuesWrapper = document.createElement('div');
      valuesWrapper.className = 'rh-simple-quick-add__values';

      values.forEach(function (value) {
        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'rh-simple-quick-add__value';
        button.dataset.rhOptionIndex = String(optionIndex);
        button.dataset.rhOptionValue = value;
        button.textContent = value;

        valuesWrapper.appendChild(button);
      });

      optionBlock.appendChild(label);
      optionBlock.appendChild(valuesWrapper);

      panel.insertBefore(optionBlock, addButton);
    });

    addButton.disabled = true;
    addButton.removeAttribute('data-variant-id');
    addButton.textContent = 'Agregar al carrito';

    if (message) {
      message.textContent = 'Selecciona las opciones disponibles.';
    }
  }

  function normalizeProductOptions(options) {
    return options.map(function (option) {
      if (typeof option === 'string') return option;
      if (option && option.name) return option.name;
      return String(option);
    });
  }

  function rhSimpleQuickAddPrepareMobile(root) {
    if (!root) return;

    rhSimpleQuickAddRenderMobileGallery(root);
    rhSimpleQuickAddRenderMobileTitle(root);
    rhSimpleQuickAddRenderMobilePrice(root, null);
    rhSimpleQuickAddRenderMobileDetailsLink(root);
    rhSimpleQuickAddRenderMobileSiblings(root);
  }

  function rhSimpleQuickAddRenderMobileGallery(root) {
    const panel = rhSimpleQuickAddGetPanel(root);
    if (!panel) return;

    const gallery = panel.querySelector('.rh-simple-quick-add__mobile-gallery');
    if (!gallery) return;

    const images = rhSimpleQuickAddGetProductImages(root);

    gallery.innerHTML = '';

    images.slice(0, 4).forEach(function (image) {
      const src = rhSimpleQuickAddGetImageSrc(image);
      if (!src) return;

      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'rh-simple-quick-add__mobile-gallery-item';
      item.dataset.rhLightboxSrc = rhSimpleQuickAddResizeImage(src, 1400);
      item.setAttribute('aria-label', 'Ver imagen de ' + (root.dataset.rhProductTitle || 'producto'));

      const img = document.createElement('img');
      img.src = rhSimpleQuickAddResizeImage(src, 360);
      img.alt = image.alt || root.dataset.rhProductTitle || '';
      img.loading = 'lazy';
      img.width = 110;
      img.height = 130;

      item.appendChild(img);
      gallery.appendChild(item);
    });

    if (!gallery.children.length) {
      const fallback = rhSimpleQuickAddGetFallbackCardImage(root);

      if (fallback) {
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'rh-simple-quick-add__mobile-gallery-item';
        item.dataset.rhLightboxSrc = rhSimpleQuickAddResizeImage(fallback, 1400);
        item.setAttribute('aria-label', 'Ver imagen de ' + (root.dataset.rhProductTitle || 'producto'));

        const img = document.createElement('img');
        img.src = rhSimpleQuickAddResizeImage(fallback, 360);
        img.alt = root.dataset.rhProductTitle || '';
        img.loading = 'lazy';
        img.width = 110;
        img.height = 130;

        item.appendChild(img);
        gallery.appendChild(item);
      }
    }
  }

  function rhSimpleQuickAddRenderMobileTitle(root) {
    const panel = rhSimpleQuickAddGetPanel(root);
    if (!panel) return;

    const title = panel.querySelector('.rh-simple-quick-add__mobile-title');
    if (!title) return;

    title.textContent = root.dataset.rhProductTitle || '';
  }

  function rhSimpleQuickAddRenderMobileDetailsLink(root) {
    const panel = rhSimpleQuickAddGetPanel(root);
    if (!panel) return;

    const link = panel.querySelector('.rh-simple-quick-add__mobile-details-link');
    if (!link) return;

    const handle = root.dataset.rhActiveHandle || root.dataset.rhProductHandle || '';
    const url = root.dataset.rhProductUrl || (handle ? '/products/' + handle : '#');

    link.href = url;
    link.setAttribute('aria-label', 'Ver detalles de ' + (root.dataset.rhProductTitle || 'este producto'));
  }

  function rhSimpleQuickAddRenderMobilePrice(root, selectedVariant) {
    const panel = rhSimpleQuickAddGetPanel(root);
    if (!panel) return;

    const priceWrapper = panel.querySelector('.rh-simple-quick-add__mobile-price');
    if (!priceWrapper) return;

    const variant = selectedVariant || rhSimpleQuickAddGetFirstAvailableVariant(root);
    const displayPrice = rhSimpleQuickAddCalculateDisplayPrice(root, variant);

    priceWrapper.innerHTML = '';

    if (!displayPrice || !displayPrice.price) return;

    const current = document.createElement('span');
    current.className = 'rh-simple-quick-add__mobile-price-current';
    current.textContent = rhSimpleQuickAddFormatMoney(root, displayPrice.price);

    priceWrapper.appendChild(current);

    if (displayPrice.compareAtPrice && displayPrice.compareAtPrice > displayPrice.price) {
      const compare = document.createElement('s');
      compare.className = 'rh-simple-quick-add__mobile-price-compare';
      compare.textContent = rhSimpleQuickAddFormatMoney(root, displayPrice.compareAtPrice);

      const badge = document.createElement('span');
      badge.className = 'rh-simple-quick-add__mobile-price-badge';
      badge.textContent = '-' + displayPrice.discountPct + '%';

      priceWrapper.appendChild(compare);
      priceWrapper.appendChild(badge);
    }
  }

  function rhSimpleQuickAddCalculateDisplayPrice(root, variant) {
    if (!root || !variant) return null;

    const enableAutoDiscountPricing = root.dataset.rhEnableAutoDiscountPricing === 'true';
    const enableGlobalPromo = root.dataset.rhEnableGlobalPromo === 'true';
    const globalDiscountPercent = Number(root.dataset.rhGlobalDiscountPercent || 0);

    const price = Number(variant.price || 0);
    const compareAtPrice = Number(variant.compare_at_price || 0);

    let discountPct = 0;

    if (enableAutoDiscountPricing) {
      if (enableGlobalPromo && globalDiscountPercent > 0) {
        discountPct = globalDiscountPercent;
      } else {
        discountPct = rhSimpleQuickAddGetHighestTagDiscount(rhSimpleQuickAddGetProductTags(root));
      }
    }

    if (discountPct > 0 && (!compareAtPrice || compareAtPrice <= price)) {
      const promoPrice = Math.round(price * (100 - discountPct) / 100);

      return {
        price: promoPrice,
        compareAtPrice: price,
        discountPct: discountPct,
        onSale: true
      };
    }

    if (compareAtPrice > price) {
      return {
        price: price,
        compareAtPrice: compareAtPrice,
        discountPct: Math.round((compareAtPrice - price) * 100 / compareAtPrice),
        onSale: true
      };
    }

    return {
      price: price,
      compareAtPrice: null,
      discountPct: 0,
      onSale: false
    };
  }

  function rhSimpleQuickAddRenderMobileSiblings(root) {
    const panel = rhSimpleQuickAddGetPanel(root);
    if (!panel) return;

    const siblingsWrapper = panel.querySelector('.rh-simple-quick-add__mobile-siblings');
    if (!siblingsWrapper) return;

    const siblings = rhSimpleQuickAddGetOriginalSiblings(root);

    siblingsWrapper.innerHTML = '';

    if (!siblings.length) {
      siblingsWrapper.hidden = true;
      return;
    }

    siblings.forEach(function (sibling) {
      const handle = rhSimpleQuickAddGetHandleFromElement(sibling);
      if (!handle) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rh-simple-quick-add__mobile-sibling';
      button.dataset.handle = handle;

      const activeHandle = root.dataset.rhActiveHandle;

      const isActive = activeHandle
        ? handle === activeHandle
        : sibling.classList.contains('is-active') || sibling.getAttribute('aria-current') === 'true';

      if (isActive) {
        button.classList.add('is-active');
        button.setAttribute('aria-current', 'true');
      }

      const label =
        sibling.getAttribute('aria-label') ||
        sibling.getAttribute('title') ||
        sibling.dataset.title ||
        sibling.dataset.color ||
        sibling.textContent.trim() ||
        'Cambiar producto';

      button.setAttribute('aria-label', label);
      button.title = label;

      const imageSrc = rhSimpleQuickAddGetSiblingImage(sibling);

      if (imageSrc) {
        const img = document.createElement('img');
        img.src = rhSimpleQuickAddResizeImage(imageSrc, 160);
        img.alt = label;
        img.loading = 'lazy';
        img.width = 80;
        img.height = 80;

        button.appendChild(img);
      } else {
        button.textContent = label.substring(0, 2).toUpperCase();
      }

      siblingsWrapper.appendChild(button);
    });

    siblingsWrapper.hidden = siblingsWrapper.children.length === 0;
  }

  function rhSimpleQuickAddGetCard(root) {
    return rhSimpleQuickAddGetCardFromElement(root);
  }

  function rhSimpleQuickAddGetCardFromElement(element) {
    if (!element) return null;

    return (
      element.closest('.card-wrapper') ||
      element.closest('.product-card-wrapper') ||
      element.closest('.slider__slide') ||
      element.closest('.grid__item')
    );
  }

  function rhSimpleQuickAddLooksLikeExternalSiblingClick(target) {
    if (!target) return false;

    const candidate = target.closest(
      '.js-sibling-swatch, [data-handle], [data-product-handle], [data-rh-product-handle], [href*="/products/"], [class*="sibling"], [class*="swatch"], [class*="color"], [class*="Color"], [class*="variant"], [class*="Variant"]'
    );

    if (!candidate) return false;
    if (candidate.closest('.rh-simple-quick-add')) return false;
    if (candidate.closest('.rh-simple-quick-add__panel')) return false;

    return true;
  }

  function rhSimpleQuickAddGetHandleFromElement(element) {
    if (!element) return '';

    const candidate = element.closest
      ? element.closest('[data-handle], [data-product-handle], [data-rh-product-handle], [href*="/products/"]')
      : null;

    if (!candidate) return '';

    const dataHandle =
      candidate.dataset.handle ||
      candidate.dataset.productHandle ||
      candidate.dataset.rhProductHandle ||
      '';

    if (dataHandle) return dataHandle;

    const href = candidate.getAttribute('href') || '';

    if (href.indexOf('/products/') > -1) {
      return href
        .split('/products/')[1]
        .split('?')[0]
        .split('#')[0]
        .replace(/\/$/, '');
    }

    return '';
  }

  function rhSimpleQuickAddStartDesktopSiblingObserver(root) {
    if (!root || rhSimpleQuickAddIsMobile()) return;

    rhSimpleQuickAddStopDesktopSiblingObserver(root);

    const card = rhSimpleQuickAddGetCard(root);
    if (!card || !window.MutationObserver) return;

    const observer = new MutationObserver(function (mutations) {
      if (!root.classList.contains('is-panel-open')) return;
      if (rhSimpleQuickAddIsMobile()) return;

      const shouldSync = mutations.some(function (mutation) {
        const target = mutation.target;

        if (!target || target.nodeType !== 1) return false;

        if (
          target.closest &&
          (
            target.closest('.rh-simple-quick-add') ||
            target.closest('.rh-simple-quick-add__panel') ||
            target.closest('.rh-simple-quick-add__lightbox')
          )
        ) {
          return false;
        }

        if (mutation.type === 'childList') {
          return true;
        }

        if (mutation.type === 'attributes') {
          return [
            'class',
            'aria-current',
            'aria-selected',
            'data-active',
            'data-handle',
            'data-product-handle',
            'data-rh-product-handle',
            'href',
            'src',
            'srcset'
          ].indexOf(mutation.attributeName) > -1;
        }

        return false;
      });

      if (shouldSync) {
        rhSimpleQuickAddQueueDesktopSiblingSync(root);
      }
    });

    observer.observe(card, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'class',
        'aria-current',
        'aria-selected',
        'data-active',
        'data-handle',
        'data-product-handle',
        'data-rh-product-handle',
        'href',
        'src',
        'srcset'
      ]
    });

    root.rhSimpleQuickAddDesktopSiblingObserver = observer;
  }

  function rhSimpleQuickAddStopDesktopSiblingObserver(root) {
    if (!root) return;

    clearTimeout(root.rhSimpleQuickAddExternalSiblingTimer);

    if (root.rhSimpleQuickAddDesktopSiblingObserver) {
      root.rhSimpleQuickAddDesktopSiblingObserver.disconnect();
      root.rhSimpleQuickAddDesktopSiblingObserver = null;
    }

    root.classList.remove('is-syncing-sibling');
    delete root.dataset.rhSyncingSibling;
  }

  function rhSimpleQuickAddQueueDesktopSiblingSync(root, fallbackHandle) {
    if (!root || rhSimpleQuickAddIsMobile()) return;
    if (!root.classList.contains('is-panel-open')) return;

    rhSimpleQuickAddResetSelection(root);
    rhSimpleQuickAddUpdate(root);

    root.classList.add('is-syncing-sibling');
    root.dataset.rhSyncingSibling = 'true';

    clearTimeout(root.rhSimpleQuickAddExternalSiblingTimer);

    root.rhSimpleQuickAddExternalSiblingTimer = setTimeout(async function () {
      const card = rhSimpleQuickAddGetCard(root);
      const activeHandle = card ? rhSimpleQuickAddFindActiveHandleInCard(card, root) : '';
      const handle = activeHandle || fallbackHandle || '';

      if (!handle) {
        root.classList.remove('is-syncing-sibling');
        delete root.dataset.rhSyncingSibling;
        rhSimpleQuickAddResetSelection(root);
        rhSimpleQuickAddUpdate(root);
        return;
      }

      if (root.dataset.rhActiveHandle === handle) {
        root.classList.remove('is-syncing-sibling');
        delete root.dataset.rhSyncingSibling;
        rhSimpleQuickAddResetSelection(root);
        rhSimpleQuickAddUpdate(root);
        return;
      }

      try {
        await rhSimpleQuickAddLoadProductByHandle(root, handle);
        rhSimpleQuickAddResetSelection(root);
        rhSimpleQuickAddUpdate(root);
      } catch (error) {
        console.warn('[RH Quick Add] No se pudo sincronizar sibling desktop:', error);

        const panel = rhSimpleQuickAddGetPanel(root);
        const message = panel
          ? panel.querySelector('.rh-simple-quick-add__message')
          : root.querySelector('.rh-simple-quick-add__message');

        if (message) {
          message.textContent = error.message || 'No se pudo cargar el producto seleccionado.';
        }

        rhSimpleQuickAddResetSelection(root);
        rhSimpleQuickAddUpdate(root);
      }

      root.classList.remove('is-syncing-sibling');
      delete root.dataset.rhSyncingSibling;
    }, 140);
  }

  function rhSimpleQuickAddHandleExternalSiblingChange(root, fallbackHandle) {
    rhSimpleQuickAddQueueDesktopSiblingSync(root, fallbackHandle);
  }

  function rhSimpleQuickAddFindActiveHandleInCard(card, root) {
    if (!card) return '';

    const activeSelectors = [
      '.js-sibling-swatch.is-active',
      '.js-sibling-swatch.active',
      '.js-sibling-swatch.selected',
      '.js-sibling-swatch[aria-current="true"]',
      '.js-sibling-swatch[aria-selected="true"]',
      '.js-sibling-swatch[data-active="true"]',

      '[data-handle].is-active',
      '[data-handle].active',
      '[data-handle].selected',
      '[data-handle][aria-current="true"]',
      '[data-handle][aria-selected="true"]',
      '[data-handle][data-active="true"]',

      '[data-product-handle].is-active',
      '[data-product-handle].active',
      '[data-product-handle].selected',
      '[data-product-handle][aria-current="true"]',
      '[data-product-handle][aria-selected="true"]',
      '[data-product-handle][data-active="true"]',

      '[data-rh-product-handle].is-active',
      '[data-rh-product-handle].active',
      '[data-rh-product-handle].selected',
      '[data-rh-product-handle][aria-current="true"]',
      '[data-rh-product-handle][aria-selected="true"]',
      '[data-rh-product-handle][data-active="true"]',

      '[href*="/products/"].is-active',
      '[href*="/products/"].active',
      '[href*="/products/"].selected',
      '[href*="/products/"][aria-current="true"]',
      '[href*="/products/"][aria-selected="true"]',
      '[href*="/products/"][data-active="true"]'
    ];

    for (let i = 0; i < activeSelectors.length; i++) {
      const candidates = Array.from(card.querySelectorAll(activeSelectors[i]));

      for (let j = 0; j < candidates.length; j++) {
        const candidate = candidates[j];

        if (candidate.closest('.rh-simple-quick-add')) continue;
        if (candidate.closest('.rh-simple-quick-add__panel')) continue;

        const handle = rhSimpleQuickAddGetHandleFromElement(candidate);

        if (handle) return handle;
      }
    }

    const preferredLinks = [
      '.card__heading a[href*="/products/"]',
      '.card-information a[href*="/products/"]',
      '.full-unstyled-link[href*="/products/"]',
      'a[href*="/products/"]'
    ];

    for (let i = 0; i < preferredLinks.length; i++) {
      const links = Array.from(card.querySelectorAll(preferredLinks[i]));

      for (let j = 0; j < links.length; j++) {
        const link = links[j];

        if (link.closest('.rh-simple-quick-add')) continue;
        if (link.closest('.rh-simple-quick-add__panel')) continue;

        const handle = rhSimpleQuickAddGetHandleFromElement(link);

        if (handle) return handle;
      }
    }

    if (root) {
      return root.dataset.rhActiveHandle || root.dataset.rhProductHandle || '';
    }

    return '';
  }

  function rhSimpleQuickAddGetOriginalSiblings(root) {
    const card = rhSimpleQuickAddGetCard(root);
    if (!card) return [];

    return Array.from(
      card.querySelectorAll(
        '.js-sibling-swatch[data-handle], [data-handle].js-sibling-swatch, [data-product-handle].js-sibling-swatch, [href*="/products/"].js-sibling-swatch'
      )
    );
  }

  function rhSimpleQuickAddGetSiblingImage(sibling) {
    if (!sibling) return '';

    const img = sibling.querySelector('img');

    if (img) {
      return img.currentSrc || img.src || img.getAttribute('src') || '';
    }

    const dataImage =
      sibling.dataset.image ||
      sibling.dataset.src ||
      sibling.dataset.imageUrl ||
      sibling.dataset.featuredImage ||
      '';

    if (dataImage) return dataImage;

    const backgroundImage = window.getComputedStyle(sibling).backgroundImage;

    if (backgroundImage && backgroundImage !== 'none') {
      const match = backgroundImage.match(/url\(["']?(.*?)["']?\)/);

      if (match && match[1]) {
        return match[1];
      }
    }

    return '';
  }

  function rhSimpleQuickAddGetFallbackCardImage(root) {
    const card = rhSimpleQuickAddGetCard(root);
    if (!card) return '';

    const img = card.querySelector('img');

    if (!img) return '';

    return img.currentSrc || img.src || img.getAttribute('src') || '';
  }

  function rhSimpleQuickAddGetProductTags(root) {
    try {
      return rhSimpleQuickAddNormalizeTags(JSON.parse(root.dataset.rhProductTags || '[]'));
    } catch (error) {
      return rhSimpleQuickAddNormalizeTags(root.dataset.rhProductTags || []);
    }
  }

  function rhSimpleQuickAddNormalizeTags(tags) {
    if (Array.isArray(tags)) return tags;

    if (typeof tags === 'string') {
      return tags
        .split(',')
        .map(function (tag) {
          return tag.trim();
        })
        .filter(Boolean);
    }

    return [];
  }

  function rhSimpleQuickAddGetHighestTagDiscount(tags) {
    let highest = 0;

    rhSimpleQuickAddNormalizeTags(tags).forEach(function (tag) {
      const cleanTag = String(tag).trim();

      if (!cleanTag.includes('%')) return;
      if (cleanTag.includes('+')) return;

      const value = Number(cleanTag.replace('%', '').trim());

      if (!Number.isNaN(value) && value > highest) {
        highest = value;
      }
    });

    return highest;
  }

  function rhSimpleQuickAddGetProductImages(root) {
    try {
      return rhSimpleQuickAddNormalizeImages(JSON.parse(root.dataset.rhProductImages || '[]'));
    } catch (error) {
      return [];
    }
  }

  function rhSimpleQuickAddNormalizeImages(productOrImages) {
    if (!productOrImages) return [];

    if (Array.isArray(productOrImages)) {
      return productOrImages.map(function (image) {
        if (typeof image === 'string') {
          return {
            src: image,
            alt: ''
          };
        }

        return {
          src: image.src || image.url || image.preview_image || '',
          alt: image.alt || ''
        };
      }).filter(function (image) {
        return image.src;
      });
    }

    const images = [];

    if (productOrImages.images && Array.isArray(productOrImages.images)) {
      productOrImages.images.forEach(function (image) {
        if (typeof image === 'string') {
          images.push({
            src: image,
            alt: productOrImages.title || ''
          });
        } else if (image && (image.src || image.url)) {
          images.push({
            src: image.src || image.url,
            alt: image.alt || productOrImages.title || ''
          });
        }
      });
    }

    if (!images.length && productOrImages.featured_image) {
      if (typeof productOrImages.featured_image === 'string') {
        images.push({
          src: productOrImages.featured_image,
          alt: productOrImages.title || ''
        });
      } else if (productOrImages.featured_image.src) {
        images.push({
          src: productOrImages.featured_image.src,
          alt: productOrImages.featured_image.alt || productOrImages.title || ''
        });
      }
    }

    return images.filter(function (image) {
      return image.src;
    });
  }

  function rhSimpleQuickAddGetImageSrc(image) {
    if (!image) return '';

    if (typeof image === 'string') return image;

    return image.src || image.url || '';
  }

  function rhSimpleQuickAddResizeImage(src, width) {
    if (!src) return '';

    if (src.indexOf('cdn/shop') > -1 || src.indexOf('cdn.shopify.com') > -1) {
      if (src.indexOf('?') > -1) {
        if (src.indexOf('width=') > -1) return src;
        return src + '&width=' + width;
      }

      return src + '?width=' + width;
    }

    return src;
  }

  function rhSimpleQuickAddFormatMoney(root, cents) {
    const amount = Number(cents || 0) / 100;
    const currency = rhSimpleQuickAddGetCurrencyCode();
    const showCurrencyCode = root && root.dataset.rhCurrencyCodeEnabled === 'true';

    try {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: currency,
        currencyDisplay: showCurrencyCode ? 'code' : 'symbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function rhSimpleQuickAddGetCurrencyCode() {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }

    if (window.theme && theme.currencyCode) {
      return theme.currencyCode;
    }

    return 'MXN';
  }

  function rhSimpleQuickAddOpenLightbox(src, alt) {
    if (!src) return;

    let lightbox = document.querySelector('.rh-simple-quick-add__lightbox');

    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'rh-simple-quick-add__lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.setAttribute('aria-label', 'Imagen ampliada del producto');

      const closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'rh-simple-quick-add__lightbox-close';
      closeButton.setAttribute('aria-label', 'Cerrar imagen');
      closeButton.textContent = '×';

      const image = document.createElement('img');
      image.className = 'rh-simple-quick-add__lightbox-image';
      image.alt = '';

      lightbox.appendChild(closeButton);
      lightbox.appendChild(image);
      document.body.appendChild(lightbox);
    }

    const image = lightbox.querySelector('.rh-simple-quick-add__lightbox-image');

    if (image) {
      image.src = src;
      image.alt = alt || '';
    }

    lightbox.classList.add('is-open');
    document.body.classList.add('rh-simple-quick-add-lightbox-open');
  }

  function rhSimpleQuickAddCloseLightbox() {
    const lightbox = document.querySelector('.rh-simple-quick-add__lightbox');

    if (!lightbox) return;

    lightbox.classList.remove('is-open');
    document.body.classList.remove('rh-simple-quick-add-lightbox-open');

    const image = lightbox.querySelector('.rh-simple-quick-add__lightbox-image');

    if (image) {
      image.removeAttribute('src');
      image.alt = '';
    }
  }

  async function rhSimpleQuickAddSubmit(root, variantId, button) {
    if (!root || !variantId) return;

    const submitButton = button || root.querySelector('.rh-simple-quick-add__add');
    const panel = rhSimpleQuickAddGetPanel(root) || root;
    const message = panel
      ? panel.querySelector('.rh-simple-quick-add__message')
      : root.querySelector('.rh-simple-quick-add__message');
    const originalText = submitButton.textContent;

    submitButton.disabled = true;
    submitButton.textContent = 'Agregando...';

    if (message) {
      message.textContent = '';
    }

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');
      const cartElement = cartDrawer || cartNotification;

      let sections = [];

      if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
        sections = cartElement.getSectionsToRender().map(function (section) {
          return section.id;
        });
      }

      if (!sections.length) {
        sections = [
          'cart-drawer',
          'cart-icon-bubble',
          'cart-live-region-text'
        ];
      }

      const payload = {
        id: Number(variantId),
        quantity: 1,
        sections: sections,
        sections_url: window.location.pathname
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || 'No se pudo agregar al carrito.');
      }

      closePanel(root);

      await rhSimpleQuickAddRefreshCart(data);

      submitButton.textContent = 'Agregado';

      setTimeout(function () {
        submitButton.textContent = originalText.trim() || 'Agregar al carrito';
        submitButton.disabled = false;
        rhSimpleQuickAddUpdate(root);
      }, 900);
    } catch (error) {
      if (message) {
        message.textContent = error.message || 'No se pudo agregar al carrito.';
      }

      submitButton.textContent = originalText.trim() || 'Agregar al carrito';
      submitButton.disabled = false;
      rhSimpleQuickAddUpdate(root);
    }
  }

  async function rhSimpleQuickAddRefreshCart(addData) {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');
    const cartElement = cartDrawer || cartNotification;

    if (
      cartElement &&
      typeof cartElement.renderContents === 'function' &&
      addData &&
      addData.sections
    ) {
      cartElement.renderContents(addData);

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));

      return;
    }

    let sections = [];

    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      sections = cartElement.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }

    if (!sections.length) {
      sections = [
        'cart-drawer',
        'cart-icon-bubble',
        'cart-live-region-text'
      ];
    }

    const sectionsResponse = await fetch(
      window.location.pathname + '?sections=' + sections.join(',')
    );

    const freshSections = await sectionsResponse.json();

    if (cartElement && typeof cartElement.renderContents === 'function') {
      cartElement.renderContents({
        id: addData && addData.id ? addData.id : null,
        sections: freshSections
      });

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    } else {
      Object.keys(freshSections).forEach(function (sectionId) {
        const html = freshSections[sectionId];

        if (!html) return;

        const container = document.getElementById(sectionId);

        if (container) {
          container.innerHTML = html;
        }
      });
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
})();